module.exports = __webpack_public_path__ + "static/img/WBZ1155-BB-1.314d03c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2027/WBZ1155-BB-1.jpg
// module id = 1nuJ
// module chunks = 0